// extracted by mini-css-extract-plugin
module.exports = {"card":"Card_card__X8Azm","iconImg":"Card_iconImg__rG-d1"};